import { createContext, useContext, useState, ReactNode, useEffect } from "react";

type Lang = "en" | "ar";

interface LangContextType {
  lang: Lang;
  toggleLang: () => void;
  isAr: boolean;
  t: (en: string, ar: string) => string;
}

const LangContext = createContext<LangContextType>({
  lang: "en",
  toggleLang: () => {},
  isAr: false,
  t: (en) => en,
});

export function LangProvider({ children }: { children: ReactNode }) {
  const [lang, setLang] = useState<Lang>(() => (localStorage.getItem("diyafa_lang") as Lang) ?? "en");

  const toggleLang = () => setLang((prev) => {
    const next = prev === "en" ? "ar" : "en";
    localStorage.setItem("diyafa_lang", next);
    return next;
  });
  const isAr = lang === "ar";

  useEffect(() => {
    document.documentElement.dir = isAr ? "rtl" : "ltr";
    document.documentElement.lang = isAr ? "ar" : "en";
  }, [isAr]);

  const t = (en: string, ar: string) => (isAr ? ar : en);

  return (
    <LangContext.Provider value={{ lang, toggleLang, isAr, t }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
